/**
 * Artbey 2026 Zip Perde (Dikey/Art) fiyat matrisleri — otomatik uretildi.
 * Kaynak: /app/artbey_fiyat_2026.pdf  (OCR + font sablonu ile cift dogrulama)
 * prices: EUR/adet · noWarranty: 1 = PDF'de kirmizi (garanti kapsami disi)
 * ELLE DUZENLEMEYIN — yeniden uret: python3 backend/artbey_write.py
 */

export const ARTBEY_MATRICES = {
  "Art 90": {
    helio: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      prices: [
        [430, 460, 489, 518, 547, 577, 606, 635, 664],
        [451, 481, 511, 542, 573, 603, 634, 665, 695],
        [472, 503, 534, 566, 598, 630, 662, 694, 726],
        [493, 525, 557, 590, 623, 657, 690, 724, 757],
        [514, 548, 581, 615, 648, 683, 718, 753, 788],
        [535, 570, 605, 640, 675, 710, 747, 783, 819],
        [556, 592, 629, 665, 702, 738, 775, 812, 850],
        [577, 615, 653, 691, 728, 766, 804, 842, 881],
        [598, 637, 677, 716, 755, 794, 834, 873, 912],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
      ],
    },
    serge: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      prices: [
        [463, 501, 538, 576, 613, 651, 688, 726, 763],
        [493, 532, 573, 614, 655, 696, 737, 778, 819],
        [522, 565, 608, 653, 697, 742, 786, 831, 875],
        [551, 598, 644, 691, 739, 787, 835, 883, 931],
        [580, 630, 680, 731, 781, 832, 884, 935, 987],
        [609, 663, 717, 770, 824, 877, 932, 987, 1042],
        [639, 696, 753, 810, 867, 924, 981, 1040, 1098],
        [668, 729, 789, 850, 910, 971, 1031, 1092, 1154],
        [697, 761, 825, 889, 953, 1017, 1082, 1146, 1210],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
      ],
    },
    transparan: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300],
      prices: [
        [466, 504, 542, 581, 619, 657, 695, 733, 772],
        [496, 536, 578, 620, 662, 704, 746, 788, 829],
        [526, 570, 614, 660, 705, 751, 796, 842, 887],
        [556, 604, 651, 699, 748, 797, 847, 896, 945],
        [586, 637, 689, 740, 791, 844, 897, 950, 1003],
        [616, 671, 726, 781, 836, 891, 948, 1004, 1061],
        [645, 704, 763, 822, 881, 939, 998, 1058, 1118],
        [675, 738, 800, 863, 925, 988, 1050, 1112, 1176],
        [705, 771, 837, 904, 970, 1036, 1102, 1168, 1234],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
      ],
    },
  },
  "Art 110": {
    helio: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      prices: [
        [458, 491, 524, 557, 589, 622, 655, 687, 720, 753, 786, 818, 851, 884, 917, 949, 982, 1015, 1048, 1080, 1113],
        [479, 512, 546, 580, 615, 649, 683, 717, 751, 785, 820, 854, 888, 922, 956, 990, 1024, 1059, 1093, 1127, 1161],
        [500, 535, 569, 604, 640, 676, 711, 747, 782, 818, 853, 889, 925, 960, 996, 1031, 1067, 1102, 1138, 1174, 1209],
        [521, 557, 593, 628, 665, 702, 739, 776, 813, 850, 887, 924, 961, 998, 1035, 1072, 1109, 1146, 1183, 1220, 1257],
        [542, 579, 616, 654, 691, 729, 767, 806, 844, 883, 921, 960, 998, 1036, 1075, 1113, 1152, 1190, 1228, 1267, 1305],
        [563, 602, 640, 679, 717, 756, 796, 835, 875, 915, 955, 995, 1035, 1075, 1114, 1154, 1194, 1234, 1274, 1314, 1353],
        [584, 624, 664, 704, 744, 784, 824, 865, 906, 948, 989, 1030, 1071, 1113, 1154, 1195, 1236, 1278, 1319, 1360, 1401],
        [605, 647, 688, 729, 771, 812, 853, 895, 937, 980, 1023, 1065, 1108, 1151, 1193, 1236, 1279, 1322, 1364, 1407, 1450],
        [626, 669, 712, 755, 797, 840, 883, 926, 968, 1012, 1057, 1101, 1145, 1189, 1233, 1277, 1321, 1365, 1409, 1454, 1498],
        [647, 692, 736, 780, 824, 868, 912, 957, 1001, 1045, 1090, 1136, 1182, 1227, 1273, 1318, 1364, 1409, 1455, 1500, 1546],
        [668, 714, 760, 805, 851, 896, 942, 988, 1033, 1079, 1124, 1171, 1218, 1265, 1312, 1359, 1406, 1453, 1500, 1547, 1594],
        [689, 736, 783, 830, 877, 924, 971, 1018, 1066, 1113, 1160, 1207, 1255, 1303, 1352, 1400, 1448, 1497, 1545, 1594, 1642],
        [710, 759, 807, 856, 904, 953, 1001, 1049, 1098, 1146, 1195, 1243, 1292, 1341, 1391, 1441, 1491, 1541, 1590, 1640, 1690],
        [731, 781, 831, 881, 931, 981, 1031, 1080, 1130, 1180, 1230, 1280, 1330, 1380, 1431, 1482, 1533, 1584, 1636, 1687, 1738],
        [752, 804, 855, 906, 957, 1009, 1060, 1111, 1163, 1214, 1265, 1316, 1368, 1419, 1470, 1523, 1576, 1628, 1681, 1734, 1786],
        [773, 826, 879, 931, 984, 1037, 1090, 1142, 1195, 1248, 1300, 1353, 1406, 1459, 1511, 1564, 1618, 1672, 1726, 1780, 1834],
        [794, 848, 903, 957, 1011, 1065, 1119, 1173, 1227, 1282, 1336, 1390, 1444, 1498, 1552, 1606, 1660, 1716, 1771, 1827, 1882],
        [815, 871, 926, 982, 1038, 1093, 1149, 1204, 1260, 1315, 1371, 1426, 1482, 1537, 1593, 1649, 1704, 1760, 1817, 1873, 1930],
        [836, 893, 950, 1007, 1064, 1121, 1178, 1235, 1292, 1349, 1406, 1463, 1520, 1577, 1634, 1691, 1748, 1805, 1862, 1920, 1978],
        [857, 916, 974, 1033, 1091, 1149, 1208, 1266, 1324, 1383, 1441, 1500, 1558, 1616, 1675, 1733, 1792, 1850, 1908, 1967, 2027],
        [878, 938, 998, 1058, 1118, 1177, 1237, 1297, 1357, 1417, 1476, 1536, 1596, 1656, 1716, 1776, 1835, 1895, 1955, 2015, 2075],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
    serge: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      prices: [
        [491, 532, 573, 614, 655, 696, 737, 778, 819, 860, 901, 942, 983, 1024, 1065, 1106, 1147, 1188, 1229, 1270, 1311],
        [521, 564, 608, 653, 697, 742, 786, 831, 875, 920, 964, 1009, 1053, 1098, 1142, 1187, 1231, 1276, 1320, 1364, 1409],
        [550, 597, 643, 691, 739, 787, 835, 883, 931, 979, 1027, 1075, 1123, 1171, 1219, 1267, 1315, 1363, 1411, 1459, 1507],
        [579, 629, 679, 730, 781, 832, 884, 935, 987, 1038, 1090, 1141, 1193, 1244, 1296, 1347, 1398, 1450, 1501, 1553, 1604],
        [608, 662, 716, 769, 823, 878, 933, 988, 1043, 1098, 1153, 1207, 1262, 1317, 1372, 1427, 1482, 1537, 1592, 1647, 1702],
        [638, 695, 752, 809, 866, 923, 982, 1040, 1098, 1157, 1215, 1274, 1332, 1391, 1449, 1507, 1566, 1624, 1683, 1741, 1800],
        [667, 728, 788, 849, 909, 970, 1030, 1092, 1154, 1216, 1278, 1340, 1402, 1464, 1526, 1588, 1650, 1712, 1773, 1835, 1897],
        [696, 760, 824, 888, 952, 1017, 1081, 1145, 1210, 1275, 1341, 1406, 1472, 1537, 1602, 1668, 1733, 1799, 1864, 1930, 1995],
        [726, 793, 861, 928, 996, 1063, 1131, 1198, 1266, 1335, 1404, 1473, 1541, 1610, 1679, 1748, 1817, 1886, 1955, 2024, 2093],
        [755, 826, 897, 968, 1039, 1110, 1181, 1252, 1323, 1394, 1466, 1539, 1611, 1684, 1756, 1828, 1901, 1973, 2045, 2118, 2190],
        [784, 859, 933, 1008, 1082, 1157, 1231, 1306, 1380, 1455, 1529, 1605, 1681, 1757, 1833, 1909, 1984, 2060, 2136, 2212, 2288],
        [813, 891, 969, 1047, 1125, 1203, 1281, 1359, 1437, 1515, 1593, 1671, 1751, 1830, 1909, 1989, 2068, 2148, 2227, 2306, 2386],
        [843, 924, 1006, 1087, 1169, 1250, 1332, 1413, 1495, 1576, 1657, 1739, 1820, 1903, 1986, 2069, 2152, 2235, 2318, 2400, 2483],
        [872, 957, 1042, 1127, 1212, 1297, 1382, 1467, 1552, 1637, 1722, 1807, 1892, 1977, 2063, 2149, 2236, 2322, 2408, 2495, 2581],
        [901, 990, 1078, 1166, 1255, 1343, 1432, 1520, 1609, 1697, 1786, 1874, 1963, 2051, 2140, 2229, 2319, 2409, 2499, 2589, 2679],
        [930, 1022, 1114, 1206, 1298, 1390, 1482, 1574, 1666, 1758, 1850, 1942, 2034, 2126, 2218, 2310, 2403, 2496, 2590, 2683, 2776],
        [960, 1055, 1151, 1246, 1341, 1437, 1532, 1628, 1723, 1819, 1914, 2009, 2105, 2200, 2296, 2391, 2487, 2584, 2680, 2777, 2874],
        [989, 1088, 1187, 1286, 1385, 1484, 1582, 1681, 1780, 1879, 1978, 2077, 2176, 2275, 2374, 2473, 2572, 2671, 2771, 2871, 2972],
        [1018, 1121, 1223, 1325, 1428, 1530, 1633, 1735, 1837, 1940, 2042, 2145, 2247, 2350, 2452, 2554, 2657, 2759, 2862, 2965, 3069],
        [1047, 1153, 1259, 1365, 1471, 1577, 1683, 1789, 1895, 2001, 2106, 2212, 2318, 2424, 2530, 2636, 2742, 2848, 2954, 3060, 3167],
        [1077, 1186, 1295, 1405, 1514, 1624, 1733, 1842, 1952, 2061, 2171, 2280, 2389, 2499, 2608, 2718, 2827, 2936, 3046, 3155, 3265],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
    transparan: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      prices: [
        [494, 536, 577, 619, 661, 702, 744, 786, 827, 869, 911, 952, 994, 1036, 1077, 1119, 1161, 1202, 1244, 1286, 1327],
        [524, 568, 613, 659, 704, 749, 795, 840, 885, 931, 976, 1021, 1067, 1112, 1157, 1203, 1248, 1293, 1339, 1384, 1429],
        [554, 602, 649, 698, 747, 796, 845, 894, 943, 992, 1041, 1090, 1139, 1188, 1237, 1286, 1335, 1384, 1433, 1482, 1531],
        [584, 635, 686, 738, 790, 843, 896, 948, 1001, 1054, 1106, 1159, 1212, 1264, 1317, 1369, 1422, 1475, 1527, 1580, 1633],
        [614, 669, 724, 779, 834, 890, 946, 1003, 1059, 1115, 1171, 1228, 1284, 1340, 1397, 1453, 1509, 1565, 1622, 1678, 1734],
        [644, 702, 761, 820, 878, 937, 997, 1057, 1117, 1177, 1237, 1296, 1356, 1416, 1476, 1536, 1596, 1656, 1716, 1776, 1836],
        [674, 736, 798, 860, 923, 985, 1047, 1111, 1174, 1238, 1302, 1365, 1429, 1492, 1556, 1620, 1683, 1747, 1811, 1874, 1938],
        [704, 770, 835, 901, 967, 1033, 1099, 1165, 1232, 1300, 1367, 1434, 1501, 1569, 1636, 1703, 1770, 1838, 1905, 1972, 2039],
        [734, 803, 873, 942, 1012, 1081, 1151, 1221, 1290, 1361, 1432, 1503, 1574, 1645, 1716, 1787, 1857, 1928, 1999, 2070, 2141],
        [764, 837, 910, 983, 1056, 1130, 1203, 1276, 1349, 1423, 1497, 1572, 1646, 1721, 1795, 1870, 1945, 2019, 2094, 2168, 2243],
        [793, 870, 947, 1024, 1101, 1178, 1255, 1332, 1409, 1485, 1562, 1640, 1719, 1797, 1875, 1953, 2032, 2110, 2188, 2266, 2345],
        [823, 904, 984, 1065, 1146, 1226, 1307, 1387, 1468, 1548, 1629, 1709, 1791, 1873, 1955, 2037, 2119, 2201, 2283, 2364, 2446],
        [853, 938, 1022, 1106, 1190, 1274, 1358, 1443, 1527, 1611, 1695, 1779, 1864, 1949, 2035, 2120, 2206, 2291, 2377, 2462, 2548],
        [883, 971, 1059, 1147, 1235, 1323, 1410, 1498, 1586, 1674, 1762, 1850, 1937, 2025, 2114, 2204, 2293, 2382, 2471, 2560, 2650],
        [913, 1005, 1096, 1188, 1279, 1371, 1462, 1554, 1645, 1737, 1828, 1920, 2011, 2103, 2194, 2287, 2380, 2473, 2566, 2659, 2751],
        [943, 1038, 1133, 1229, 1324, 1419, 1514, 1609, 1704, 1800, 1895, 1990, 2085, 2180, 2275, 2371, 2467, 2564, 2660, 2757, 2853],
        [973, 1072, 1171, 1270, 1368, 1467, 1566, 1665, 1764, 1862, 1961, 2060, 2159, 2258, 2357, 2455, 2554, 2654, 2754, 2855, 2955],
        [1003, 1106, 1208, 1310, 1413, 1515, 1618, 1720, 1823, 1925, 2028, 2130, 2233, 2335, 2438, 2540, 2643, 2745, 2849, 2953, 3057],
        [1033, 1139, 1245, 1351, 1457, 1564, 1670, 1776, 1882, 1988, 2094, 2200, 2307, 2413, 2519, 2625, 2731, 2837, 2943, 3051, 3158],
        [1063, 1173, 1282, 1392, 1502, 1612, 1722, 1831, 1941, 2051, 2161, 2271, 2380, 2490, 2600, 2710, 2819, 2929, 3039, 3149, 3260],
        [1093, 1206, 1320, 1433, 1547, 1660, 1773, 1887, 2000, 2114, 2227, 2341, 2454, 2568, 2681, 2794, 2908, 3021, 3135, 3248, 3362],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
  },
  "Art 130": {
    helio: {
      widths: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700],
      heights: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
      prices: [
        [467, 537, 607, 677, 747, 817, 887, 957, 1027, 1097, 1167, 1237, 1307],
        [509, 582, 658, 733, 809, 885, 961, 1036, 1112, 1188, 1263, 1339, 1415],
        [551, 630, 708, 790, 871, 953, 1034, 1115, 1197, 1278, 1359, 1441, 1522],
        [593, 677, 762, 846, 933, 1020, 1107, 1194, 1281, 1368, 1456, 1543, 1630],
        [635, 725, 815, 905, 995, 1088, 1181, 1273, 1366, 1459, 1552, 1644, 1737],
        [677, 773, 869, 964, 1060, 1156, 1254, 1353, 1451, 1549, 1648, 1746, 1845],
        [719, 821, 922, 1023, 1125, 1226, 1328, 1432, 1536, 1640, 1744, 1848, 1952],
        [761, 868, 975, 1082, 1190, 1297, 1404, 1511, 1621, 1730, 1840, 1950, 2060],
        [803, 916, 1029, 1141, 1254, 1367, 1480, 1593, 1705, 1821, 1936, 2052, 2167],
        [845, 964, 1082, 1201, 1319, 1437, 1556, 1674, 1793, 1911, 2033, 2154, 2275],
        [887, 1011, 1135, 1260, 1384, 1508, 1632, 1756, 1880, 2005, 2129, 2256, 2382],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
      ],
    },
    serge: {
      widths: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700],
      heights: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
      prices: [
        [500, 587, 673, 760, 846, 933, 1019, 1106, 1192, 1279, 1365, 1452, 1538],
        [559, 656, 757, 857, 958, 1058, 1159, 1259, 1360, 1460, 1561, 1661, 1762],
        [617, 729, 841, 955, 1070, 1184, 1298, 1413, 1527, 1642, 1756, 1870, 1985],
        [676, 801, 927, 1053, 1181, 1309, 1438, 1566, 1695, 1823, 1951, 2080, 2208],
        [734, 874, 1014, 1153, 1293, 1435, 1577, 1720, 1862, 2004, 2147, 2289, 2431],
        [793, 946, 1100, 1254, 1407, 1561, 1717, 1873, 2029, 2186, 2342, 2498, 2655],
        [851, 1019, 1186, 1354, 1521, 1689, 1856, 2027, 2197, 2367, 2537, 2708, 2878],
        [910, 1091, 1273, 1454, 1636, 1817, 1999, 2180, 2364, 2548, 2733, 2917, 3101],
        [968, 1164, 1359, 1555, 1750, 1945, 2141, 2336, 2532, 2730, 2928, 3126, 3324],
        [1027, 1236, 1446, 1655, 1864, 2074, 2283, 2492, 2702, 2911, 3123, 3335, 3547],
        [1085, 1309, 1532, 1755, 1979, 2202, 2425, 2649, 2872, 3095, 3319, 3545, 3771],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
      ],
    },
    transparan: {
      widths: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700],
      heights: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
      prices: [
        [503, 591, 679, 766, 854, 942, 1030, 1118, 1206, 1294, 1382, 1469, 1557],
        [563, 663, 765, 868, 970, 1073, 1175, 1277, 1380, 1482, 1585, 1687, 1790],
        [623, 737, 851, 969, 1086, 1203, 1320, 1437, 1554, 1671, 1788, 1906, 2023],
        [683, 812, 941, 1070, 1201, 1333, 1465, 1597, 1728, 1860, 1992, 2124, 2255],
        [742, 886, 1030, 1173, 1317, 1463, 1610, 1756, 1902, 2049, 2195, 2342, 2488],
        [802, 961, 1119, 1277, 1435, 1594, 1755, 1916, 2077, 2238, 2399, 2560, 2721],
        [862, 1035, 1208, 1381, 1554, 1727, 1900, 2075, 2251, 2426, 2602, 2778, 2953],
        [922, 1110, 1297, 1485, 1672, 1860, 2047, 2235, 2425, 2615, 2805, 2996, 3186],
        [982, 1184, 1386, 1588, 1791, 1993, 2195, 2397, 2599, 2804, 3009, 3214, 3419],
        [1042, 1259, 1475, 1692, 1909, 2126, 2342, 2559, 2776, 2993, 3212, 3432, 3651],
        [1102, 1333, 1564, 1796, 2027, 2259, 2490, 2721, 2953, 3184, 3416, 3650, 3884],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
  },
  "Art 140": {
    helio: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      prices: [
        [482, 516, 550, 583, 617, 651, 685, 718, 752, 786, 820, 853, 887, 921, 954, 988, 1022, 1056, 1089, 1123, 1157],
        [511, 545, 580, 615, 650, 686, 721, 756, 791, 826, 861, 896, 932, 967, 1002, 1037, 1072, 1107, 1142, 1178, 1213],
        [540, 575, 610, 647, 684, 720, 757, 793, 830, 866, 903, 940, 976, 1013, 1049, 1086, 1122, 1159, 1196, 1232, 1269],
        [569, 605, 642, 679, 717, 755, 793, 831, 869, 907, 945, 983, 1021, 1059, 1097, 1135, 1173, 1211, 1249, 1287, 1325],
        [598, 636, 674, 712, 750, 789, 829, 868, 908, 947, 986, 1026, 1065, 1105, 1144, 1184, 1223, 1262, 1302, 1341, 1381],
        [627, 666, 706, 745, 785, 824, 865, 906, 947, 987, 1028, 1069, 1110, 1151, 1192, 1232, 1273, 1314, 1355, 1396, 1437],
        [655, 696, 737, 778, 819, 860, 901, 943, 985, 1028, 1070, 1112, 1154, 1197, 1239, 1281, 1323, 1366, 1408, 1450, 1493],
        [684, 727, 769, 811, 854, 896, 938, 981, 1024, 1068, 1112, 1155, 1199, 1243, 1286, 1330, 1374, 1417, 1461, 1505, 1548],
        [713, 757, 801, 844, 888, 932, 976, 1019, 1063, 1108, 1153, 1198, 1244, 1289, 1334, 1379, 1424, 1469, 1514, 1559, 1604],
        [742, 787, 832, 878, 923, 968, 1013, 1058, 1103, 1149, 1195, 1242, 1288, 1335, 1381, 1428, 1474, 1521, 1567, 1614, 1660],
        [771, 817, 864, 911, 957, 1004, 1050, 1097, 1144, 1190, 1237, 1285, 1333, 1381, 1429, 1477, 1525, 1572, 1620, 1668, 1716],
        [800, 848, 896, 944, 992, 1040, 1088, 1136, 1184, 1232, 1280, 1328, 1377, 1427, 1476, 1525, 1575, 1624, 1674, 1723, 1772],
        [829, 878, 927, 977, 1026, 1076, 1125, 1175, 1224, 1274, 1323, 1372, 1422, 1473, 1523, 1574, 1625, 1676, 1727, 1777, 1828],
        [857, 908, 959, 1010, 1061, 1112, 1163, 1213, 1264, 1315, 1366, 1417, 1468, 1519, 1571, 1623, 1675, 1727, 1780, 1832, 1884],
        [886, 939, 991, 1043, 1095, 1148, 1200, 1252, 1305, 1357, 1409, 1461, 1514, 1566, 1618, 1672, 1726, 1779, 1833, 1886, 1940],
        [915, 969, 1023, 1076, 1130, 1184, 1237, 1291, 1345, 1399, 1452, 1506, 1560, 1613, 1667, 1721, 1776, 1831, 1886, 1941, 1996],
        [944, 999, 1054, 1109, 1165, 1220, 1275, 1330, 1385, 1440, 1495, 1550, 1606, 1661, 1716, 1771, 1826, 1883, 1939, 1995, 2052],
        [973, 1029, 1086, 1143, 1199, 1256, 1312, 1369, 1425, 1482, 1538, 1595, 1651, 1708, 1765, 1821, 1878, 1934, 1992, 2050, 2108],
        [1002, 1060, 1118, 1176, 1234, 1292, 1350, 1408, 1466, 1523, 1581, 1639, 1697, 1755, 1813, 1871, 1929, 1987, 2045, 2105, 2164],
        [1031, 1090, 1149, 1209, 1268, 1328, 1387, 1446, 1506, 1565, 1625, 1684, 1743, 1803, 1862, 1922, 1981, 2040, 2100, 2159, 2220],
        [1059, 1120, 1181, 1242, 1303, 1364, 1424, 1485, 1546, 1607, 1668, 1728, 1789, 1850, 1911, 1972, 2033, 2093, 2154, 2215, 2276],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
    serge: {
      widths: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
      prices: [
        [515, 557, 599, 641, 683, 725, 767, 809, 851, 893, 935, 977, 1019, 1061, 1103, 1145, 1187, 1229, 1271, 1313, 1355],
        [552, 597, 642, 688, 733, 778, 824, 869, 915, 960, 1006, 1051, 1097, 1142, 1188, 1233, 1279, 1324, 1370, 1415, 1461],
        [590, 637, 685, 734, 783, 832, 881, 930, 979, 1028, 1077, 1125, 1174, 1223, 1272, 1321, 1370, 1419, 1468, 1517, 1566],
        [627, 678, 729, 780, 832, 885, 937, 990, 1042, 1095, 1147, 1200, 1252, 1305, 1357, 1409, 1462, 1514, 1567, 1619, 1672],
        [664, 718, 773, 828, 882, 938, 994, 1050, 1106, 1162, 1218, 1274, 1330, 1386, 1442, 1498, 1553, 1609, 1665, 1721, 1777],
        [701, 759, 817, 875, 933, 991, 1051, 1110, 1170, 1229, 1288, 1348, 1407, 1467, 1526, 1586, 1645, 1704, 1764, 1823, 1883],
        [738, 800, 861, 923, 984, 1046, 1107, 1170, 1233, 1296, 1359, 1422, 1485, 1548, 1611, 1674, 1737, 1800, 1862, 1925, 1988],
        [775, 840, 905, 970, 1035, 1100, 1165, 1231, 1297, 1363, 1430, 1496, 1563, 1629, 1695, 1762, 1828, 1895, 1961, 2027, 2094],
        [812, 881, 949, 1018, 1086, 1155, 1224, 1292, 1361, 1431, 1500, 1570, 1640, 1710, 1780, 1850, 1920, 1990, 2060, 2129, 2199],
        [849, 921, 993, 1066, 1138, 1210, 1282, 1354, 1426, 1498, 1571, 1644, 1718, 1791, 1865, 1938, 2011, 2085, 2158, 2231, 2305],
        [887, 962, 1038, 1113, 1189, 1264, 1340, 1415, 1491, 1566, 1642, 1719, 1795, 1872, 1949, 2026, 2103, 2180, 2257, 2334, 2410],
        [924, 1003, 1082, 1161, 1240, 1319, 1398, 1477, 1556, 1635, 1714, 1793, 1873, 1953, 2034, 2114, 2194, 2275, 2355, 2436, 2516],
        [961, 1043, 1126, 1208, 1291, 1373, 1456, 1538, 1621, 1703, 1786, 1868, 1951, 2035, 2118, 2202, 2286, 2370, 2454, 2538, 2621],
        [998, 1084, 1170, 1256, 1342, 1428, 1514, 1600, 1686, 1772, 1858, 1944, 2030, 2116, 2203, 2290, 2378, 2465, 2552, 2640, 2727],
        [1035, 1125, 1214, 1303, 1393, 1482, 1572, 1661, 1751, 1840, 1930, 2019, 2109, 2198, 2288, 2378, 2469, 2560, 2651, 2742, 2832],
        [1072, 1165, 1258, 1351, 1444, 1537, 1630, 1723, 1816, 1909, 2002, 2095, 2188, 2281, 2374, 2466, 2561, 2655, 2749, 2844, 2938],
        [1109, 1206, 1302, 1399, 1495, 1592, 1688, 1784, 1881, 1977, 2074, 2170, 2267, 2363, 2459, 2556, 2652, 2750, 2848, 2946, 3044],
        [1146, 1246, 1346, 1446, 1546, 1646, 1746, 1846, 1946, 2046, 2146, 2246, 2346, 2446, 2545, 2645, 2745, 2845, 2947, 3048, 3149],
        [1184, 1287, 1390, 1494, 1597, 1701, 1804, 1907, 2011, 2114, 2218, 2321, 2425, 2528, 2631, 2735, 2838, 2942, 3045, 3150, 3255],
        [1221, 1328, 1434, 1541, 1648, 1755, 1862, 1969, 2076, 2183, 2290, 2397, 2504, 2610, 2717, 2824, 2931, 3038, 3145, 3252, 3360],
        [1258, 1368, 1479, 1589, 1699, 1810, 1920, 2031, 2141, 2251, 2362, 2472, 2583, 2693, 2803, 2914, 3024, 3134, 3245, 3355, 3466],
      ],
      noWarranty: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      ],
    },
  },
};
